import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const GET_GALLERY_CATEGORY_TYPE = `${API_URL}/gallery/category-list`

export const service = {
  getGalleryCategoryType: (params: ParamsModel) => {
    return axios.get(GET_GALLERY_CATEGORY_TYPE, {params})
  },
}
